(function () {
	// globals
	EWO.ToolSendCredentials = {};

	// utility functions
	function handleFileSelect(event) {
		const file = event.target.files[0];
		const importBtn = $('.js-import-sections');
		importBtn.prop('disabled', !file);
	}

	// app functions
	EWO.ToolSendCredentials.rederToolSendCredentials = function (ctx) {
		var urlQueryString = new URLSearchParams(ctx.querystring);
		var filter = Object.fromEntries(urlQueryString);
		$.extend(filter, ctx.params);
		$.get('/version.json')
			.done(function (version) {
				$('.js-page-container').html(ejs.rr('/app/election/operations/templates/toolSendCredentials.ejs', { version: version }));
				refreshUsers();
			});

		EWO.ToolSendCredentials.filter = filter;
		setTimeout(() => {
			refreshQueue();
		}, 1000);
	}
	async function refreshUsers() {
		const electionId = EWO.ToolSendCredentials.filter.electionId;
		EWO.ToolSendCredentials.filter.allUsers = [];
		const allUsers = EWO.ToolSendCredentials.filter.allUsers;
		$('.js-users-log-content').text("Loading...");
		try {

			const response = await $.ajax({
				url: `/api/v1/Boundaries?electionId=${electionId}`,
				type: 'GET'
			});
			allUsers.push(...response.rows);

			renderLogUsersFiltered(allUsers, '');
		} catch (error) {
			// Gestione degli errori
			console.error('Errore durante il recupero dei dati:', error);
		}
	}
	function renderLogUsersFiltered(allUsers, filter) {
		const logUsers = [];
		const header = ['idUser', 'username', 'email', 'constituency'];
		const columnWidths = [10, 20, 30, 20]; // Larghezza di ogni colonna

		// Aggiungi l'intestazione con padding
		logUsers.push(header.map((col, index) => col.padEnd(columnWidths[index])).join('\t'));

		const usersFiltered = allUsers.filter(user => user.username.toUpperCase().includes(filter.toUpperCase()));
		for (const user of usersFiltered) {
			// Aggiungi ogni riga con padding
			logUsers.push([
				user.id.toString().padEnd(columnWidths[0]),
				user.username.padEnd(columnWidths[1]),
				user.email ? user.email.padEnd(columnWidths[2]) : '-'.padEnd(columnWidths[2]),
				user.municipalityDesc.padEnd(columnWidths[3])
			].join('\t'));
		}
		logUsers.push('');
		logUsers.push(`Numero totale di utenti: ${usersFiltered.length}`);
		const logContentUsers = logUsers.map(line => line.trim()).join('\n');
		$('.js-users-log-content').text(logContentUsers);

	}
	// funzione che aggiunge una riga rossa .js-users-log-content la riga è un input
	function logUserSendResult(riga, type = 'secondary') {
		// aggiungo a .js-users-log-content la riga
		$('.js-users-log-content').append(`<div class="alert alert-${type}">${riga}</div>`);
		// scrolla verso l'ultima riga
		$('.js-users-log-container').scrollTop($('.js-users-log-container')[0].scrollHeight);
	}
	// events



	// Modifica l'handler del click sul pulsante js-send-credentials
	$(document).on('click', '.js-send-credentials', function (ev) {
		ev.preventDefault();
		// Mostra la modale di conferma
		$('#sendCredentialsModal').modal('show');
	});

	// Aggiungi l'handler per la conferma dell'invio
	$(document).on('click', '.js-confirm-send-credentials', function (ev) {
		ev.preventDefault();
		const electionId = EWO.ToolSendCredentials.filter.electionId;
		const namePart = $('.js-users-filter').val();
		// Nascondi la modale
		$('#sendCredentialsModal').modal('hide');

		$.ajax({
			url: `/api/v1/Elections/sendUsernames/${electionId}?namePart=${namePart}`,
			type: 'POST',
			success: function (response) {
				logUserSendResult(`Inviate in coda ${response} email`, 'success');
			},
			error: function () {
				logUserSendResult(`Errore durante l'invio degli utenti`, 'danger');
			}
		});


	});
	// Aggiungi l'handler per la conferma dell'invio
	$(document).on('click', '.js-close-modal', function (ev) {
		ev.preventDefault();
		$('#sendCredentialsModal').modal('hide');
	});
	$(document).on('keyup', '.js-users-filter', function (ev) {
		ev.preventDefault();
		const filter = $(this).val();
		renderLogUsersFiltered(EWO.ToolSendCredentials.filter.allUsers, filter);
	});
	// startup
	$(document).on('click', '.js-refresh-list', function (ev) {
		ev.preventDefault();
		$('.js-users-filter').val('');
		refreshUsers();
	});



	// Modifica l'handler del click sul pulsante js-reset-passwords
	$(document).on('click', '.js-reset-passwords', function (ev) {
		ev.preventDefault();
		// Mostra la modale di conferma
		$('#resetPasswordsModal').modal('show');
	});

	// Aggiungi l'handler per la conferma del reset password
	$(document).on('click', '.js-confirm-reset-passwords', function (ev) {
		ev.preventDefault();
		const electionId = EWO.ToolSendCredentials.filter.electionId;
		const namePart = $('.js-users-filter').val();
		// Nascondi la modale
		$('#resetPasswordsModal').modal('hide');


		$.ajax({
			url: `/api/v1/Elections/sendPasswordReset/${electionId}?namePart=${namePart}`,
			type: 'POST',
			success: function (response) {
				logUserSendResult(`Reset password in coda ${response} email`, 'success');
			},
			error: function () {
				logUserSendResult(`Errore durante il reset delle password`, 'danger');
			}
		});

	});
	$(document).on('click', '.js-close-modal-reset-passwords', function (ev) {
		ev.preventDefault();
		$('#resetPasswordsModal').modal('hide');
	});

	// Variabile per memorizzare i dati originali
	let originalLogData = '';

	// Event handler per il campo di ricerca
	$(document).on('keyup', '.js-coda-search', function() {
		const searchText = $(this).val().toLowerCase();
		if (!originalLogData) {
			originalLogData = $('.js-coda-log-content').text();
		}
		
		if (!searchText) {
			$('.js-coda-log-content').text(originalLogData);
			return;
		}

		const lines = originalLogData.split('\n');
		const header = lines[0]; // Salvo l'intestazione
		const dataLines = lines.slice(1); // Tutte le righe tranne l'intestazione
		const filteredLines = dataLines.filter(line => line.toLowerCase().includes(searchText));
		$('.js-coda-log-content').text([header, ...filteredLines].join('\n'));
	});

	// Modifico la funzione refreshQueue per salvare i dati originali
	async function refreshQueue() {
		const action = $('.js-action-input').val();
		const selectedStatus = $('input[name="statusFilter"]:checked').val();
		let status = [];

		// Gestione dello stato selezionato
		switch (selectedStatus) {
			case 'all':
				status = ''; // Tutti gli stati
				break;
			case 'in-queue':
				status = '1' // In coda
				break;
			case 'sent':
				status = '0'; // Inviata
				break;
			case 'error':
				status = '-1'; // Errore
				break;
		}

		try {
			const response = await $.ajax({
				url: '/api/EwoTask',
				type: 'GET',
				data: {
					action: action,
					status: status
				}
			});

			const mapState = {
				'1': 'In coda',
				'0': 'Inviata',
				'-1': 'Errore',
				'2': 'In coda',
				'3': 'In coda',
				'4': 'In coda',
				'5': 'In coda',
				'6': 'In coda',
				'7': 'In coda',
			}

			// Intestazione delle colonne
			const header = [
				'ID'.padEnd(4),
				'AZIONE'.padEnd(8),
				'STATO'.padEnd(8),
				'DATA'.padEnd(20),
				'RIFERIMENTO'.padEnd(50),
				'LOG'.padEnd(100)
			].join('\t');

			// Formatta e mostra i risultati
			const formattedResults = response.rows.map(task => {
				// Sostituisco \r\n con la loro rappresentazione testuale
				const logText = (task.log || '').replace(/\r/g, '\\r').replace(/\n/g, '\\n');
				
				return [
					task.id.toString().padEnd(4),
					task.action.padEnd(8), 
					mapState[task.state].padEnd(8),
					task.creationDate.padEnd(20),
					(task.refDdata || '').padEnd(50),
					logText.padEnd(100)
				].join('\t');
			}).join('\n');

			if (formattedResults) {
				const fullContent = header + '\n' + formattedResults;
				originalLogData = fullContent;
				$('.js-coda-log-content').text(fullContent);
			} else {
				originalLogData = 'Nessun risultato trovato';
				$('.js-coda-log-content').text(originalLogData);
			}
		} catch (error) {
			console.error('Errore durante il recupero delle task:', error);
			originalLogData = 'Errore durante il recupero dei dati';
			$('.js-coda-log-content').text(originalLogData);
		}
	}

	// Event handler per il pulsante di refresh
	$(document).on('click', '.js-refresh-queue', function (ev) {
		ev.preventDefault();
		refreshQueue();
	});

	// Event handler per i radio button
	$(document).on('change', 'input[name="statusFilter"]', function () {
		refreshQueue();
	});

	//routes
	page('/election/:electionId/toolSendCredentials', EWO.ToolSendCredentials.rederToolSendCredentials);


})();
// test